import { Consts } from '@shared/consts';
import { FeatureToggleSettings } from './featuresToggleSettings.model';

export function getStoredFeatureToggles(): FeatureToggleSettings[] {
	return JSON.parse(localStorage.getItem(Consts.Storage.AkitaStores) ?? '{}')?.FeatureToggleStore?.featureToggles ?? [];
}

export function isFeatureToggleActive(flagId: string): boolean {
	return getStoredFeatureToggles().find((ff) => ff.id === flagId)?.isActive ?? false;
}
